import { createAsyncThunk } from "@reduxjs/toolkit";

import { instance } from "../../axios/axios";

export const triggerInventoryRestock = createAsyncThunk(
  "inventory/triggerInventoryRestock",
  async ({ managerRecId }, { rejectWithValue, getState }) => {
    try {
      const token = getState().auth.token;
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };
      const { data } = await instance.post(
        "/inventory/portal/trigger-inventory-restock",
        { managerRecId },
        config
      );
      return data;
    } catch (error) {
      // return custom error message from backend if present
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const wipeDataInputTask = createAsyncThunk(
  "inventory/wipeDataInputTask",
  async ({ recId }, { rejectWithValue, getState }) => {
    try {
      const token = getState().auth.token;
      const { data } = await instance.delete(
        `/inventory/portal/data-input-task/${recId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      return data;
    } catch (error) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);



export const getAssignedInventoryItems = createAsyncThunk(
  "inventory/getAssignedInventoryItems",
  async ({ empName }, { rejectWithValue, getState }) => {
    try {
      // Send the caller's login (thread #1585 round 16) — step one of two, same as
      // submitAssignInventory in task/taskActions.js: the server's login check on
      // /get/line-items-by-emp goes on only once this is live.
      const token = getState()?.auth?.token;
      const { data } = await instance.get(`/inventory/portal/get/line-items-by-emp/${empName}`, {
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      });
      return data?.data;
    } catch (error) {
      // return custom error message from backend if present
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);